import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { StyledP } from "../../Styled/Text"
import { Price } from "../../Price/Price"
import ImageCTA from "../../Image/ImageCTA"
import AddToCart from "../../Product/AddToCart/AddToCart"
import { Link } from "gatsby"

type Props = {
  item: any
  small?: boolean
}

const UpsellCard = styled.div`
  ${tw`bg-light p-1`}
  border-radius: 10px;
  padding: 16px;
`
const Wrapper = tw.div`w-full flex flex-row justify-between`
const ImageWrapper = styled.div`
  ${tw`relative`}
  width: 120px;
  height: 120px;
`
const ImageWrapperInner = styled.div`
  ${tw`relative w-full h-full overflow-hidden`}
  border-radius: 10px;
  width: 120px;
  height: 120px;
`
const ContentSection = tw.div`flex justify-start w-full`
const Content = tw.div`flex flex-col justify-between ml-1-6`
const SubtitleWrapper = styled.div`
  ${tw`flex flex-row items-start`}
`
const Title = tw(StyledP)`mr-1 mb-1 capitalize`
const PriceWrapper = tw.div`mr-1 mb-1 inline-block md:block` // stylesmall
const Subtitle = tw.div`mr-1`

const CartUpsellProductCards: React.FC<Props> = ({ item }) => {
  return (
    <>
      <UpsellCard>
        <Wrapper>
          <ContentSection>
            <ImageWrapper>
              <ImageWrapperInner>
                <Link to={`/products/${item?.handle}`}>
                  <ImageCTA image={item?.images[0]?.src} objectFit={`fill`} />
                </Link>
              </ImageWrapperInner>
            </ImageWrapper>
            <Content>
              <Link to={`/products/${item?.handle}`}>
                <Title>{item?.title}</Title>
              </Link>
              <SubtitleWrapper>
                <PriceWrapper className="title_small">
                  <Price price={item?.variants[0]?.priceV2} compareAtPrice={item?.variants[0]?.compareAtPriceV2 || undefined} layout={`product`} />
                </PriceWrapper>
              </SubtitleWrapper>
              <AddToCart selectedVariant={item?.variants[0]} selectedVariants={item?.variants} type={`minimal`} />
            </Content>
          </ContentSection>
        </Wrapper>
      </UpsellCard>
    </>
  )
}

export default React.memo(CartUpsellProductCards)
